import { Box } from '@mui/material'

function SectionCard({ children, className = '', sx, ...rest }) {
  return (
    <Box className={className} sx={sx} {...rest}>
      {children}
    </Box>
  )
}

export default SectionCard
